import { render, staticRenderFns } from "./SignInUp.vue?vue&type=template&id=3b7a45bd"
import script from "./SignInUp.vue?vue&type=script&lang=js"
export * from "./SignInUp.vue?vue&type=script&lang=js"
import style0 from "./SignInUp.vue?vue&type=style&index=0&id=3b7a45bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports